import { render } from "./ygq.vue?vue&type=template&id=43d83166&scoped=true"
import script from "./ygq.vue?vue&type=script&lang=js"
export * from "./ygq.vue?vue&type=script&lang=js"

import "./ygq.vue?vue&type=style&index=0&id=43d83166&lang=scss&scoped=true"

import exportComponent from "/home/code/aiyu-before-pc/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d83166"]])

export default __exports__